import Http from '@/utils/http'
const baseUrl = '/app/student'

/**
 *项目状态
 * @param params
 * 
*/

export const status = params => Http.get(`${baseUrl}/sz/team/status`, { params } )

/**
 *评价详情
 * @param category
 * @param teamId
 * 
*/

export const evaluateInfo = (category, teamId) => Http.get(`${baseUrl}/sz/team/${category}/${teamId}/score`)

/**
 *提交评分
 * @param params
 * 
*/

export const doEvaluate = params => Http.post(`${baseUrl}/sz/team/${params.category}/${params.teamId}/score`, params.result )

/**
 *团队排行
 * @param category
 * @param classId
 * 
*/

export const teamRanking = (category, classId) => Http.get(`${baseUrl}/sz/team/${category}/${classId}/top`)
